import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import ScaleModal from "reboron/ScaleModal";
import { IoClose } from "react-icons/io5";

class Modal extends Component {
  UNSAFE_componentWillReceiveProps = (nextProps) => {
    const { id, modal } = nextProps;

    if (modal !== this.props.modal) {
      if (id === modal.id && modal.show) {
        this.modal.show();
      } else {
        this.modal.hide();
      }
    }
  };

  close = () => {
    const { close, id } = this.props;
    close(id);
  };

  render() {
    const { id, size, title, body, closeOnClick, keyboard, headerClassNames } =
      this.props;

    const width = size === "lg" ? "70%" : "inherit";
    const modalStyle = {
      width
    };

    return (
      <div id={id}>
        <ScaleModal
          ref={(ref) => (this.modal = ref)}
          className="view-modal"
          modalStyle={modalStyle}
          closeOnClick={closeOnClick}
          keyboard={keyboard}
        >
          <div className={`modal-${size}`}>
            <div className={`modal-header ${headerClassNames}`}>
              <button type="button" className="close" onClick={this.close}>
                <IoClose />
              </button>
              {title ? <h2 className="modal-title">{title}</h2> : null}
            </div>
            <div className="modal-body">{body}</div>
            <div className="modal-footer" />
          </div>
        </ScaleModal>
      </div>
    );
  }
}

Modal.defaultProps = {
  size: "md"
};

Modal.propTypes = {
  id: PropTypes.string.isRequired,
  size: PropTypes.string,
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.object
  ]),
  body: PropTypes.element,
  close: PropTypes.func,
  modal: PropTypes.object,
  closeOnClick: PropTypes.bool,
  keyboard: PropTypes.bool,
  headerClassNames: PropTypes.string
};

Modal.defaultProps = {
  closeOnClick: true,
  keyboard: true,
  title: ""
};

function mapStatesToProps(state) {
  return {
    state: state.reducers,
    modal: state.reducers.modal
  };
}

export default connect(mapStatesToProps)(Modal);
